import s from './MineButton.module.sass';

import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mineActions, selectMine } from '$store/mine';
import {
  lockShake,
  startShakeDetection,
  stopShakeDetection,
} from '../../../services/shake';
import { toastActions } from '$store/toast';
import { startTapDetector, stopTapDetector } from '../../../services/tapper';
import { statReachGoal } from '$utils';

export const MineButton: FC = () => {
  const dispatch = useDispatch();
  const { squad } = useSelector(selectMine);
  //
  // useEffect(() => {
  //   startTapDetector();
  //
  //   return () => {
  //     stopTapDetector();
  //   };
  // }, []);

  useEffect(() => {
    startShakeDetection();

    return () => {
      stopShakeDetection();
    };
  }, []);

  const handlePress = () => {
    lockShake();
    dispatch(mineActions.shake());
    //dispatch(toastActions.setToastFail('Shake your phone!'));

    statReachGoal('mine_button_pressed');
  };

  return (
    <div className={s.wrap}>
      <div
        id="shake_button"
        className={s.button}
        style={{
          backgroundImage: `url(${squad?.url ?? ''})`,
        }}
        onClick={handlePress}
      ></div>
    </div>
  );
};
